import { Component, computed, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'table-datatable-rma-description',
  templateUrl: './datatable-rma-description.component.html',
  styleUrls: ['./datatable-rma-description.component.scss'],
  imports: [MatIconModule, MatTooltipModule],
})
export class DatatableRmaDescriptionComponent {
  description = input<string>('');
  performanceDescription = input<string>();
  parsedDeviceId = input<number>();
  identifiedDeviceId = input<number>();
  isInvalid = input<boolean>(false);

  isWarning = computed(() => {
    const parsed = this.parsedDeviceId();
    const identified = this.identifiedDeviceId();
    const isMismatch = parsed != null && identified != null && parsed !== identified;
    return isMismatch || this.isInvalid();
  });

  parts = computed(() => {
    const text = this.description();
    const id = this.parsedDeviceId();
    if (!text || !id) return null;

    const strId = String(id);
    const index = text.indexOf(strId);
    if (index === -1) return null;

    return {
      before: text.slice(0, index),
      id: strId,
      after: text.slice(index + strId.length),
    };
  });
}
